export default URL;
//# sourceMappingURL=URL.web.js.map